module.exports = __webpack_public_path__ + "img/manual3.a4580bd6.jpg";